import { useState } from 'react';
import type { MentionUser } from '../../lib/access';
import { RichEditor } from '../RichEditor';
import { ErrorBoundary } from '../ErrorBoundary';
import { Avatar } from './AttributeSidebar';

/** ⌘ on Apple platforms, Ctrl elsewhere — matches RichEditor's Mod-Enter. */
const SUBMIT_KEYS =
  typeof navigator !== 'undefined' && /Mac|iPhone|iPad/.test(navigator.platform || navigator.userAgent) ? '⌘↵' : 'Ctrl+↵';

/**
 * New-comment box under the activity feed. A thin wrapper over RichEditor — the
 * @mention suggestion behaviour is RichEditor's own and is unchanged here.
 */
export function CommentComposer({
  value,
  onChange,
  onSubmit,
  busy,
  mentionUsers,
  myEmail,
  showDecisionHint = true,
}: {
  value: string;
  onChange: (v: string) => void;
  onSubmit: () => void;
  busy: boolean;
  mentionUsers: MentionUser[];
  myEmail: string;
  /** "Comments don't change the decision." — only meaningful where there is one. */
  showDecisionHint?: boolean;
}) {
  // an attachment still uploading is not in `value` yet — commenting now would drop it
  const [uploading, setUploading] = useState(false);
  const submit = () => {
    if (!busy && !uploading && value.trim()) onSubmit();
  };
  return (
    <div className="req-composer">
      {myEmail && <Avatar email={myEmail} />}
      <div>
        <ErrorBoundary fallback={(m) => <p className="error">editor failed: {m}</p>}>
          <RichEditor
            value={value}
            onChange={onChange}
            placeholder="add a comment…"
            disabled={busy}
            mentionUsers={mentionUsers}
            onSubmit={submit}
            onUploadingChange={setUploading}
          />
        </ErrorBoundary>
        <div className="req-actions">
          {showDecisionHint && <span className="muted text-xs">Comments don't change the decision.</span>}
          <span className="req-spacer" />
          <span className="muted text-xs">{SUBMIT_KEYS} to comment</span>
          <button
            className="btn btn-primary"
            disabled={busy || uploading || !value.trim()}
            title={uploading ? 'Wait for the upload to finish' : undefined}
            onClick={submit}
          >
            Comment
          </button>
        </div>
      </div>
    </div>
  );
}
